import React from 'react';
import PropTypes from 'prop-types';
import GamedayScaffold from '../components/GamedayScaffold';

const GamedayScaffoldContainer = ({
    componentMap
}) => {

    return (
        <GamedayScaffold componentMap={componentMap} />
    );
};

GamedayScaffoldContainer.propTypes = {
    componentMap: PropTypes.object
};

export default GamedayScaffoldContainer;
